import type { SwitchProps } from './const';
import { Switch as ArcoSwitch } from '@arco-design/web-react';
import { cn } from '@utils';
import { forwardRef } from 'react';
import './index.less';

function Switch(props: SwitchProps, ref: React.Ref<HTMLButtonElement>) {
  const { superSmall, ...restProps } = props;

  return (
    <div
      className={cn('wg-switch', {
        'wg-switch--super-small': superSmall,
      })}
    >
      <ArcoSwitch ref={ref} size="small" {...restProps} />
    </div>
  );
}

const SwitchComponent = forwardRef<HTMLButtonElement, SwitchProps>(Switch);
SwitchComponent.displayName = 'Switch';

export default SwitchComponent;

export type { SwitchProps };
